exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".consentemail-box label{display:block}.consentemail-box .checkbox-box{width:auto;padding-right:20px;float:left}.consentemail-box .checkbox-box label{padding-top:6px}.consentemail-box .checkbox-box input{margin-top:6px}.consentemail-box .consentemail{display:none}.consentemail-box .radiobutton-box{margin-left:-15px}.consentemail-box .radiobutton-box label:after{display:none}.consentemail-box .message label{margin-top:6px;margin-bottom:0}@media (max-width:768px){#render-container .consentemail-box label{margin-bottom:10px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/stylus-loader!./js-src/markdown-editor/modules/consentemail/consentemail.styl
// module id = 50
// module chunks = 0 1